import {Injectable} from '@angular/core';
import {AuthProvider} from '../../../domain/auth/auth-provider';
import {AppConfigService} from '../../../../service/config/app-config.service';
import {CachedWsResourceClient} from '../../../private_util/client/cached-http-ws-Resource-client';
import {RequestService} from '../../../service/request.service';
import {WsDaoEventEntityType, WsRef, WsTicketSigningPackage} from '@lifeislife/lifeislife-ws-api';
import {ResourceCacheService} from '../../../../util/cache/resource-cache.service';

@Injectable({
  providedIn: 'root',
})
export class TicketSigningPackageWsClient extends CachedWsResourceClient<WsTicketSigningPackage, WsRef<WsTicketSigningPackage>> {

  constructor(private injectedRequestService: RequestService,
              private injectectedCacheService: ResourceCacheService,
              private injectedAuthService: AuthProvider,
              private injectedAppConfigService: AppConfigService) {
    super('/front/ticketSigningPackage', injectedAppConfigService, injectedRequestService, injectedAuthService,
      WsDaoEventEntityType.TICKET_SIGNING_PACKAGE, injectectedCacheService);
  }


}
